const DEVICE_WIDTH = {
  XS: 639.98,
};

export default DEVICE_WIDTH;
